import logging from '@/core/logging.service';

type ComponentType = object | (() => object);

class ComponentResolver {
    components = new Map<string, ComponentType>();
    fallback: ComponentType | undefined;

    constructor(private context: string) {
    }

    register(alias: string, component: ComponentType) {
        if (this.components.get(alias)) {
            throw new Error(`${this.context}: ${alias} already registered`);
        }
        this.components.set(alias, component);
    }

    registerFallback(component: ComponentType) {
        this.fallback = component;
    }

    resolve(alias: string): ComponentType {
        const component = this.components.get(alias);
        if (!component) {
            if (this.fallback) {
                logging.warn(`${this.context}: ${alias} not registered, using fallback`);
                return this.fallback;
            } else {
                const msg = `${this.context}: ${alias} not registered and no default component`;
                logging.warn(msg);
                throw new Error(msg);
            }
        }
        return component;
    }
}

export const blockResolver = new ComponentResolver('block');
export const pageResolver = new ComponentResolver('page');
